import React from 'react';

// TODO: do a proper not found component

const NotFound = () => {
  return <div>Not Found</div>;
};

export default NotFound;
